export const CUSTOMER_SEARCHORDER_REQUEST = "CUSTOMER_SEARCHORDER_REQUEST";
export const CUSTOMER_SEARCHORDER_SUCCESS = "CUSTOMER_SEARCHORDER_SUCCESS";
export const CUSTOMER_SEARCHORDER_FAIL = "CUSTOMER_SEARCHORDER_FAIL";

export const MERCHANT_ORDER_LIST_REQUEST = "MERCHANT_ORDER_LIST_REQUEST";
export const MERCHANT_ORDER_LIST_SUCCESS = "MERCHANT_ORDER_LIST_SUCCESS";
export const MERCHANT_ORDER_LIST_FAIL = "MERCHANT_ORDER_LIST_FAIL";

export const MERCHANT_ORDER_READ_REQUEST = "MERCHANT_ORDER_READ_REQUEST";
export const MERCHANT_ORDER_READ_SUCCESS = "MERCHANT_ORDER_READ_SUCCESS";
export const MERCHANT_ORDER_READ_FAIL = "MERCHANT_ORDER_READ_FAIL";
export const MERCHANT_ORDER_READ_RESET = "MERCHANT_ORDER_READ_RESET";

export const MERCHANT_ORDER_ACCEPT_REQUEST = "MERCHANT_ORDER_ACCEPT_REQUEST";
export const MERCHANT_ORDER_ACCEPT_SUCCESS = "MERCHANT_ORDER_ACCEPT_SUCCESS";
export const MERCHANT_ORDER_ACCEPT_FAIL = "MERCHANT_ORDER_ACCEPT_FAIL";
export const MERCHANT_ORDER_ACCEPT_RESET = "MERCHANT_ORDER_ACCEPT_RESET";

export const MERCHANT_ORDER_SHIPMENT_REQUEST = "MERCHANT_ORDER_SHIPMENT_REQUEST";
export const MERCHANT_ORDER_SHIPMENT_SUCCESS = "MERCHANT_ORDER_SHIPMENT_SUCCESS";
export const MERCHANT_ORDER_SHIPMENT_FAIL = "MERCHANT_ORDER_SHIPMENT_FAIL";
export const MERCHANT_ORDER_SHIPMENT_RESET = "MERCHANT_ORDER_SHIPMENT_RESET";

export const ADMIN_ORDER_LIST_REQUEST = "ADMIN_ORDER_LIST_REQUEST";
export const ADMIN_ORDER_LIST_SUCCESS = "ADMIN_ORDER_LIST_SUCCESS";
export const ADMIN_ORDER_LIST_FAIL = "ADMIN_ORDER_LIST_FAIL";

export const ADMIN_ORDER_STATUS_CHANGE_REQUEST = "ADMIN_ORDER_STATUS_CHANGE_REQUEST";
export const ADMIN_ORDER_STATUS_CHANGE_SUCCESS = "ADMIN_ORDER_STATUS_CHANGE_SUCCESS";
export const ADMIN_ORDER_STATUS_CHANGE_FAIL = "ADMIN_ORDER_STATUS_CHANGE_FAIL";

export const ADMIN_ORDER_UPDATE_REQUEST = "ADMIN_ORDER_UPDATE_REQUEST";
export const ADMIN_ORDER_UPDATE_SUCCESS = "ADMIN_ORDER_UPDATE_SUCCESS";
export const ADMIN_ORDER_UPDATE_FAIL = "ADMIN_ORDER_UPDATE_FAIL";

export const ADMIN_ALLORDERSLIST_REQUEST = "ADMIN_ALLORDERSLIST_REQUEST";
export const ADMIN_ALLORDERSLIST_SUCCESS = "ADMIN_ALLORDERSLIST_SUCCESS";
export const ADMIN_ALLORDERSLIST_FAIL = "ADMIN_ALLORDERSLIST_FAIL";

export const ADMIN_SINGLEORDER_REQUEST = "ADMIN_SINGLEORDER_REQUEST";
export const ADMIN_SINGLEORDER_SUCCESS = "ADMIN_SINGLEORDER_SUCCESS";
export const ADMIN_SINGLEORDER_FAIL = "ADMIN_SINGLEORDER_FAIL";

export const ADMIN_SINGLEORDER_SEARCH_REQUEST = "ADMIN_SINGLEORDER_SEARCH_REQUEST";
export const ADMIN_SINGLEORDER_SEARCH_SUCCESS = "ADMIN_SINGLEORDER_SEARCH_SUCCESS";
export const ADMIN_SINGLEORDER_SEARCH_FAIL = "ADMIN_SINGLEORDER_SEARCH_FAIL";

export const ADMIN_SINGLEORDER_MESSAGELOG_ADD_REQUEST = "ADMIN_SINGLEORDER_MESSAGELOG_ADD_REQUEST";
export const ADMIN_SINGLEORDER_MESSAGELOG_ADD_SUCCESS = "ADMIN_SINGLEORDER_MESSAGELOG_ADD_SUCCESS";
export const ADMIN_SINGLEORDER_MESSAGELOG_ADD_FAIL = "ADMIN_SINGLEORDER_MESSAGELOG_ADD_FAIL";

export const ADMIN_ALLORDER_SEARCH_REQUEST = "ADMIN_ALLORDER_SEARCH_REQUEST";
export const ADMIN_ALLORDER_SEARCH_SUCCESS = "ADMIN_ALLORDER_SEARCH_SUCCESS";
export const ADMIN_ALLORDER_SEARCH_FAIL = "ADMIN_ALLORDER_SEARCH_FAIL";
